import { Label, Progress } from "semantic-ui-react";

export default function UploadProgressBar({ uploads = [] }) {
  return (
    <div>
      {uploads.map(upload => {
        return (
          <Progress
            key={upload.id}
            progress
            size={"small"}
            color={upload.percent < 100 ? "blue" : "green"}
            indicating={upload.percent < 100}
            percent={upload.percent}
          >
            <Label>{upload.file.name}</Label>
          </Progress>
        );
      })}
    </div>
  );
}
